import { useSyncExternalStore } from 'react';
import { readInputPreferences, saveInputPreferences, inputPreferences, type InputPreferences } from './input-preferences';

let state = { preferences: readInputPreferences(), error: '' };
const listeners = new Set<() => void>();
const notify = () => listeners.forEach(f => f());
const subscribe = (f: () => void) => { listeners.add(f); return () => { listeners.delete(f); }; };
export const subscribeInputPreferences = subscribe;
export const currentInputPreferences = () => state.preferences;
export function useInputPreferences() {
  const value = useSyncExternalStore(subscribe, () => state);
  const update = (partial: Partial<InputPreferences>) => {
    const preferences = inputPreferences({ ...state.preferences, ...partial });
    const saved = saveInputPreferences(preferences);
    state = { preferences, error: saved ? '' : 'Could not save on this device. These controls last until you reload or close the app.' }; notify();
  };
  return { ...value, update };
}
export const showInputGuide = () => window.dispatchEvent(new Event('streamit-input-guide'));
export function refreshInputPreferences() { state = { preferences: readInputPreferences(), error: '' }; notify(); }
